import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { pluralize } from "inflection";

//Actions
//import { pantrySelectItemById } from "../../actions/pantry";
import { openItemModal } from "../../actions/pantry";

import { Typography, Button, Checkbox } from "@mui/material";

//Utility Functions
import { convertToTitleCase } from "../../utils/recipe";
import ItemsList from "./ItemsList";

const PantryItemObject = ({ item, index, openItemModal }) => {
  console.log(item);

  const formatItemName = () => {
    let name = item?.name?.names?.default || "Pantry Item";
    let quantity = "";

    if (item.amount && item.amount.unit) {
      if (item.amount.unit.type === "self" || item.amount.unit.type === "count") {
        // Show quantity and unit
        quantity = item.amount.quantity + " ";
      }
    }

    // Pluralize name if quantity is greater than 1
    if (quantity > 1) {
      name = pluralize(name);
    }

    return `${quantity}${convertToTitleCase(name)}`.trim();
  };

  const formatDate = (expiry) => {
    if (expiry && expiry.date) {
      const now = new Date();
      const expiryDate = new Date(expiry.date);
      const diffTime = expiryDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      let expiryText = "-";
      let textColor = "text-secondaryText-700";

      if (diffDays <= 0) {
        expiryText = "0d";
        textColor = "text-rose-600";
      } else if (diffDays === 1) {
        expiryText = "1d";
        textColor = "text-rose-600";
      } else if (diffDays <= 3) {
        expiryText = `${diffDays}d`;
        textColor = "text-amber-600";
      } else if (diffDays <= 7) {
        expiryText = `${diffDays}d`;
      } else if (diffDays <= 30) {
        const weeks = Math.floor(diffDays / 7);
        expiryText = `${weeks}w`;
      } else if (diffDays <= 365) {
        const months = Math.floor(diffDays / 30);
        expiryText = `${months}m`;
      } else {
        const years = Math.floor(diffDays / 365);
        expiryText = `${years}y`;
      }
      return (
        <div className="h-full flex items-center">
          <Typography variant="subtitle1" className={`leading-snug text-sm ${textColor}`}>
            {expiryText}
          </Typography>
        </div>
      );
    } else {
      return (
        <div className="h-full flex items-center">
          <Typography variant="subtitle1" className="leading-snug text-secondaryText-600 mr-2 text-sm">
            -
          </Typography>
        </div>
      );
    }
  };

  return (
    <div className={`${index % 2 === 0 ? "bg-background" : "bg-neutral-100"} py-[0.0625rem]`}>
      <div className="pr-4 pl-2 my-2 h-[2.45rem] w-full">
        <div className="h-full flex flex-row items-center w-full justify-between">
          <div className="flex flex-row items-center">
            <div className="flex-shrink-0 mr-2">
              <Checkbox
                value={item.selected}
                onClick={() => console.log("TODO: pantrySelectItemById(item.pantryId, location")}
                disableRipple
                className="py-0"
              />
            </div>
            <div className="flex-grow min-w-0 flex flex-col">
              <Button
                onClick={() => openItemModal(item.id)}
                className="w-full justify-normal hover:bg-transparent text-start"
                disableRipple
                fullWidth
              >
                <div className="flex flex-col">
                  <div className="truncate">
                    <Typography variant="subtitle1" className="leading-snug font-medium truncate">
                      {formatItemName()}
                    </Typography>
                  </div>
                  {item && item.unit && item.unit.type !== "self" && (
                    <Typography
                      variant="subtitle2"
                      className="leading-snug font-normal text-xs text-mainGreen-600 truncate"
                    >
                      {`${item.amount} ${item.unit.shortName ? item.unit.shortName : item.unit.displayName} (${
                        item.percentRemaining
                      }%)`}
                    </Typography>
                  )}
                </div>
              </Button>
            </div>
          </div>

          <div className="flex-shrink-0 ml-2">{formatDate(item.expiry)}</div>
        </div>
      </div>
    </div>
  );
};

PantryItemObject.propTypes = {
  item: PropTypes.object.isRequired,
  location: PropTypes.string.isRequired,
  openItemModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { openItemModal })(PantryItemObject);
